import axios from "axios";

export default axios.create({
    baseURL: `https://hbrvideocallapi-70871274448.europe-west2.run.app`
});